import { render } from "./SearchIndexList.vue?vue&type=template&id=0bfcf441&scoped=true"
import script from "./SearchIndexList.vue?vue&type=script&lang=js"
export * from "./SearchIndexList.vue?vue&type=script&lang=js"

import "./SearchIndexList.vue?vue&type=style&index=0&id=0bfcf441&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bfcf441"

export default script